<div class="menu-item" [class.waiter]="configurationModel.isWaiterActor()" woa-activatable (onActivate)="selectItem()">
    @if (menuModel.showItemImages()(fromSearch() ? undefined : category())) {
        <div class="menu-item-image"
             [ngClass]="{
                 'unavailable': canShowDetails() && showUnavailable(),
                 'empty': !image()
             }">
            @if (image()) {
                <img class="menu-item-image-object" alt="" [woa-image-cache]="image()">
            }
        </div>
    }
    @if (menuItem() && !menuModel.showItemImages()(fromSearch() ? undefined : category()) && configurationModel.isWaiterActor()) {
        <div class="menu-item-icon" woa-touchable>
            {{ menuModel.itemIconText()(menuItem()) }}
        </div>
    }
    <div class="menu-item-details"
         [ngClass]="{'aligned-with-image': !configurationModel.isWaiterActor() && menuModel.showItemImages()(fromSearch() ? undefined : category())}">
        <div class="menu-item-details-header">
            <div class="menu-item-details-header-main">
                @if (canShowDetails() && (featureTag() || menuItem()?.sellable.bonusPoints)) {
                    <div class="menu-item-details-header-main-promos">
                        @if (featureTag()) {
                            <div class="menu-item-details-header-main-promos-promo">
                                {{ featureTag() }}
                            </div>
                        }
                        @if (!informational() && menuItem()?.sellable.bonusPoints) {
                            <div class="menu-item-details-header-main-promos-promo">
                                {{ 'woa.button.order.bonusPoints' | translate:{amount: menuItem().sellable.bonusPoints} }}
                            </div>
                        }
                    </div>
                }
                <div class="menu-item-details-header-main-title">
                    <div class="menu-item-details-header-main-title-name">
                        {{ menuModel.itemName()(menuItem()) }}
                    </div>
                    @if (canShowDetails() && !informational() && menuModel.itemSizes()(menuItem()); as menuItemSizes) {
                        @if (menuModel.itemSizeSummary()(menuItem()); as sizeNames) {
                            <div class="menu-item-details-header-main-title-sizes">
                                @for (sizeName of sizeNames; track sizeName; let i = $index) {
                                    <div class="menu-item-details-header-main-title-sizes-size"
                                         [class.unavailable]="menuModel.itemOutOfStock()(menuItemSizes[i].menuItem)">{{ sizeName }}
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
            @if (canShowDetails() && showOutOfStock()) {
                <div class="menu-item-details-header-stock">
                    {{ 'woa.label.order.outOfStock' | translate }}
                </div>
            }
            @if (canShowDetails() && showAtLimit()) {
                <div class="menu-item-details-header-stock">
                    {{ 'woa.label.order.atLimit' | translate }}
                </div>
            }
        </div>
        @if (category() && showCategoryPath() || (configurationModel.isConsumerActor() && menuModel.getMenuItemDescription(menuItem()))) {
            <div class="menu-item-details-body">
                @if (category() && showCategoryPath()) {
                    <div class="menu-item-details-body-category" woa-activatable (onActivate)="selectCategory($event)">
                        {{ menuModel.getCategoryPath()(category()) }}
                    </div>
                }
                @if (configurationModel.isConsumerActor() && menuModel.getMenuItemDescription(menuItem())) {
                    <div class="menu-item-details-body-description"
                         [innerHtml]="menuModel.getMenuItemDescription(menuItem()) | html"></div>
                }
            </div>
        }
        @if (canShowDetails()) {
            <div class="menu-item-details-footer">
                @if (!informational()) {
                    <div class="menu-item-details-footer-pricing" [class.dimmed]="configurationModel.isWaiterActor()">
                        <div class="menu-item-details-footer-pricing-price">
                            @if (menuItem()?.sellable.guestPrice) {
                                <div class="menu-item-details-footer-pricing-price-guest">
                                    {{ menuItem()?.sellable.defaultGuestPrice | woaCurrency }}
                                </div>
                            }
                            <div class="menu-item-details-footer-pricing-price-actual"
                                 [ngClass]="{'discounted': menuItem().sellable.guestPrice}">
                                {{ menuItem()?.sellable.defaultPrice | woaCurrency }}
                            </div>
                        </div>
                        @if (menuModel.itemSizeQualifier()(menuItem()); as qualifier) {
                            <div class="menu-item-details-footer-pricing-size">
                                {{ qualifier }}
                            </div>
                        }
                    </div>
                }
                <woa-dietary-panel class="menu-item-details-footer-dietary"
                                   [sellable]="menuItem()?.sellable"
                                   [showKilojoules]="configurationModel.isConsumerActor()"></woa-dietary-panel>
            </div>
        }
    </div>
    @if (menuItem() && configurationModel.isWaiterActor() && !informational()) {
        @if (menuModel.itemSizes()(menuItem())) {
            <div class="menu-item-add" woa-touchable woa-activatable
                 (onActivate)="toggleDirectAddSizes()">
                <woa-toggle class="menu-item-add-toggle" [active]="showSizeSelection()"></woa-toggle>
            </div>
        } @else {
            <div class="menu-item-add" woa-touchable woa-activatable #directAdd="woaActivatable"
                 (onActivate)="selectItem(true,true,true, menuItem(), directAdd)">
                <woa-icon class="menu-item-add-icon" [name]="'plus'"></woa-icon>
            </div>
        }
    }
</div>
@if (canShowDetails() && !informational() && menuModel.itemSizes()(menuItem()); as menuItemSizes) {
    <div #sizeSelection class="size-selection" woa-activatable (onActivate)="selectItem()">
        @for (menuItemSize of menuItemSizes; track menuItemSize.menuItem.sellable.sellableId) {
            <woa-button class="size-selection-size" [class.unavailable]="menuModel.itemOutOfStock()(menuItemSize.menuItem)"
                        [prominence]="ButtonProminence.LOW" [tier]="ButtonTier.SECOND"
                        [icon]="'plus'" [label]="menuModel.getSizeAbbreviation(menuItemSize.sellableSize) | literal"
                        [overrideOutlineBorderColor]="true" [overrideOutlineForegroundColor]="true"
                        (onActivate)="selectItem(true,true,true,menuItemSize.menuItem)"></woa-button>
        }
    </div>
}
@if (canShowDetails() && menuItem()?.pairingNotes) {
    <div class="pairing-notes" woa-activatable (onActivate)="selectItem()"
         [innerHtml]="menuItem().pairingNotes | html"></div>
}
